import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { getStyles, getNumberOfRowsForTextOpenEnded } from '../../utils';
import { transformPrompt } from '../../../../../../utils';
import TextInput from '../TextInput';

export default function Columns({
  rowId,
  rowRefId,
  rowOrder,
  columns,
  openEndedStyle,
  openEndedInputSize,
  minLength,
  maxLength,
  showRequiredInputSymbol,
}) {
  const { answerStyle, inputStyle, containerClasses } = getStyles(
    openEndedInputSize,
    openEndedStyle,
  );

  return (
    <div className={`${answerStyle} scrollbox`}>
      {columns.map((column, index) => (
        <Fragment>
          <div id={column.id} className={containerClasses}>
            <div className="answer--matrix-open-ended-column-label inline-children">
              {column.required && showRequiredInputSymbol && (
                <span className="answer--matrix-open-ended-column-required">
                  *
                </span>
              )}
              <div
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: transformPrompt(column.label) || '&nbsp;',
                }}
              />
            </div>
            <TextInput
              rowId={rowId}
              rowRefId={rowRefId}
              rowOrder={rowOrder}
              columnId={column.id}
              columnRefId={column.refId}
              columnOrder={index}
              openEndedInputSize={openEndedInputSize}
              minLength={minLength}
              maxLength={maxLength}
              required={column.required}
              inputStyle={inputStyle}
              rows={getNumberOfRowsForTextOpenEnded(openEndedInputSize)}
            />
          </div>
        </Fragment>
      ))}
    </div>
  );
}

Columns.propTypes = {
  rowId: PropTypes.number,
  rowRefId: PropTypes.string,
  rowOrder: PropTypes.number,
  columns: PropTypes.array,
  openEndedStyle: PropTypes.string,
  openEndedInputSize: PropTypes.string,
  minLength: PropTypes.number,
  maxLength: PropTypes.number,
  showRequiredInputSymbol: PropTypes.bool,
};
